/**
 * Стадия снежного фронта: плотность осадков, гололед, видимость.
 */
export interface FrontStage {
  /** Идентификатор стадии */
  id: string;
  /** Отображаемое имя */
  name: string;
  /** Множитель плотности снегопада */
  dens: number;
  /** Множитель нарастания гололеда */
  ice: number;
  /** Вклад в ухудшение видимости */
  vis: number;
}

/**
 * Последовательность стадий фронта (warn → … → after).
 */
export const FRONT_STAGES: readonly FrontStage[] = [
  { id: "warn", name: "Предупреждение", dens: 0.35, ice: 0.05, vis: 0.08 },
  { id: "start", name: "Начало снегопада", dens: 0.7, ice: 0.12, vis: 0.14 },
  { id: "build", name: "Усиление фронта", dens: 1.15, ice: 0.28, vis: 0.24 },
  { id: "peak", name: "Пиковая нагрузка", dens: 1.7, ice: 0.45, vis: 0.4 },
  { id: "ease", name: "Ослабление", dens: 0.85, ice: 0.22, vis: 0.18 },
  { id: "after", name: "Последствия", dens: 0.4, ice: 0.18, vis: 0.1 },
];
